import type { ReactNode } from 'react';
import { FormDialog } from '../../../components/common/FormDialog';

/**
 * Talep tiplerinin create/edit form kroması — artık ortak `FormDialog`'un ince bir
 * sarmalayıcısı (geçmişte bu dosya kromayı kendisi taşıyordu; `FormDialog` onun
 * genelleştirilmiş hâli).
 */
export function DemandFormDialog(props: {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void;
  submitting: boolean;
  error: unknown;
  children: ReactNode;
  submitLabel?: string;
}) {
  return <FormDialog {...props} />;
}
